type PanelProps = {
    children: JSX.Element;
};

import style from "./StatPanel.module.scss";

export const StatPanel = ({ children }: PanelProps): JSX.Element => {
    return <div className={style.panelContainer}>{children}</div>;
};
